<template>
    <div id="app">
        <HeaderSection />
        <main>
            <router-view />
        </main>
        <ContactSection />
        <FooterSection />

        <PrivacyPolicyModal :is-open="privacyModalOpen" @close="privacyModalOpen = false" />
        <TermsOfServiceModal :is-open="termsModalOpen" @close="termsModalOpen = false" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, provide, computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import HeaderSection from '@/components/organisms/Header.vue';
import ContactSection from '@/components/organisms/ContactSection.vue';
import FooterSection from '@/components/organisms/Footer.vue';
import PrivacyPolicyModal from '@/components/organisms/PrivacyPolicyModal.vue';
import TermsOfServiceModal from '@/components/organisms/TermsOfServiceModal.vue';

export default defineComponent({
    name: 'BlogLayout',
    components: {
        HeaderSection,
        ContactSection,
        FooterSection,
        PrivacyPolicyModal,
        TermsOfServiceModal,
    },
    setup() {
        const { locale } = useI18n();
        const route = useRoute();

        // Sync i18n locale with route param (same pattern as App.vue via useSeoHead)
        const currentLocale = computed(() => {
            const routeLocale = route.params.locale as string;
            return (routeLocale === 'en' || routeLocale === 'lt') ? routeLocale : 'en';
        });

        watchEffect(() => {
            locale.value = currentLocale.value;
        });

        // Modal state (same pattern as App.vue — Header/Footer depend on this)
        const privacyModalOpen = ref(false);
        const termsModalOpen = ref(false);

        provide('legalModals', {
            openPrivacyModal: () => {
                privacyModalOpen.value = true;
            },
            openTermsModal: () => {
                termsModalOpen.value = true;
            },
        });

        return {
            privacyModalOpen,
            termsModalOpen,
        };
    },
});
</script>
